/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, Input, OnDestroy, inject } from '@angular/core';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { Field } from '@src/app/shared/field/Field';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { ChartHolder } from '@src/app/shared/chart/chart-holder';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-chart-holder',
    templateUrl: './chart-holder.component.html',
    styleUrls: ['./chart-holder.component.scss'],
    imports: [MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule]
})
export class ChartHolderComponent implements OnDestroy {
    private cds = inject(ConfirmDialogService);


    @Input() chartHolder: ChartHolder;
    @Input() config: FormConfig;

    ngOnDestroy() {
        this.chartHolder?.destroy();
    }

    removeChart() {
        this.cds.open($localize `Remove Chart`, $localize `Remove ` + this.chartHolder.getName(), () => {
           this.config.charts.removeChart(this.chartHolder);
        });
    }
    isMetric(f: Field) {
        if (f.type === 'number') {
            if (f.value !== 'id' && f.value !== 'revision' && f.value !== 'refNr' && f.value !== 'teamId') {
                return true;
            }
        }
        return false;

    }

}
